// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-icon-wrapper {
  width: var(--boxx-brand-icon-wrapper-width, 100%);
  text-align: var(--boxx-brand-icon-wrapper-align, center);
  z-index: var(--boxx-brand-icon-wrapper-z-index, 999);
}
.brand-icon-wrapper ion-img {
  width: 157px;
  color: var(--boxx-brand-icon-color, white);
  margin-left: 24px;
  padding-top: 19px;
  margin-bottom: 7px;
}

#qr {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 32px;
  height: 32px;
}

@media screen and (min-width: 960px) {
  .brand-icon-wrapper {
    position: var(--boxx-brand-icon-wrapper-position, absolute);
    top: var(--ion-safe-area-top, var(--boxx-brand-icon-wrapper-top, 0));
    width: var(--boxx-brand-icon-wrapper-width, 100%);
    text-align: var(--boxx-brand-icon-wrapper-align, center);
    z-index: var(--boxx-brand-icon-wrapper-z-index, 999);
    width: auto;
    left: 50%;
  }
  .brand-icon-wrapper ion-img {
    margin: var(--boxx-brand-icon-margin, auto);
    width: var(--boxx-brand-icon-width, auto);
    height: var(--boxx-brand-icon-height, 38px);
    color: var(--boxx-brand-icon-color, white);
    margin-top: 6px;
  }
}
.logo_ENDIGITAL {
  width: 58px !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/main-header-icon/main-header-icon.component.scss"],"names":[],"mappings":"AAAA;EAGE,iDAAA;EACA,wDAAA;EACA,oDAAA;AADF;AAGE;EAEE,YAAA;EAEA,0CAAA;EAGA,iBAAA;EAEA,iBAAA;EACA,kBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAWA;EACA;IACE,2DAAA;IACA,oEAAA;IACA,iDAAA;IACA,wDAAA;IACA,oDAAA;IAEA,WAAA;IACA,SAAA;EATA;EAYA;IACE,2CAAA;IACA,yCAAA;IACA,2CAAA;IACA,0CAAA;IACA,eAAA;EAVF;AACF;AAeA;EACE,sBAAA;AAbF","sourcesContent":[".brand-icon-wrapper {\n  //position: var(--boxx-brand-icon-wrapper-position, absolute);\n  //top: var(--ion-safe-area-top, var(--boxx-brand-icon-wrapper-top, 0));\n  width: var(--boxx-brand-icon-wrapper-width, 100%);\n  text-align: var(--boxx-brand-icon-wrapper-align, center);\n  z-index: var(--boxx-brand-icon-wrapper-z-index, 999);\n\n  ion-img {\n    //margin: var(--boxx-brand-icon-margin, auto);\n    width: 157px;// var(--boxx-brand-icon-width, 56px);\n    //height: var(--boxx-brand-icon-height, 20px);\n    color: var(--boxx-brand-icon-color, white);\n    //margin-top: 6px;\n\n    margin-left: 24px;\n    //margin-top: 28px;\n    padding-top: 19px;\n    margin-bottom: 7px;\n  }\n}\n\n#qr{\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  width: 32px;\n  height: 32px;\n}\n\n\n@media screen and (min-width: 960px) {\n.brand-icon-wrapper {\n  position: var(--boxx-brand-icon-wrapper-position, absolute);\n  top: var(--ion-safe-area-top, var(--boxx-brand-icon-wrapper-top, 0));\n  width: var(--boxx-brand-icon-wrapper-width, 100%);\n  text-align: var(--boxx-brand-icon-wrapper-align, center);\n  z-index: var(--boxx-brand-icon-wrapper-z-index, 999);\n  \n  width: auto;\n  left: 50%;\n\n\n  ion-img {\n    margin: var(--boxx-brand-icon-margin, auto);\n    width: var(--boxx-brand-icon-width, auto);\n    height: var(--boxx-brand-icon-height, 38px);\n    color: var(--boxx-brand-icon-color, white);\n    margin-top: 6px;\n  }\n}\n\n}\n\n.logo_ENDIGITAL{\n  width: 58px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
